{
  "dropzoneLabel": "DropZone",
  "selectPlaceholder": "Επιλέξτε ένα αντικείμενο",
  "tableResizer": "Αλλαγή μεγέθους",
  "expand": "Expand",
  "collapse": "Collapse",
  "colorSwatchPicker": "Color swatches"
}
